/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-face-neutral-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zM5.625 8.438a1.563 1.563 0 113.125 0 1.563 1.563 0 01-3.125 0zm8.125 5.312h-7.5V12.5h7.5v1.25zM12.812 10a1.563 1.563 0 110-3.125 1.563 1.563 0 010 3.125z"/>'
  }
})
